import React, { Component, PropTypes } from 'react';
import styles from '../Header.scss';
import InlineSVG from 'react-svg-inline';
import locationIcon from '../../../imgs/location-icon.svg';

export default class HeaderLocation extends Component {
  render() {
    return (
      <div className={styles.location}>
        <InlineSVG
          svg={locationIcon}
          className={styles.locationIcon} />
        Санкт-Петербург
      </div>
    );
  }
}



HeaderLocation.propTypes = {
};



/** WEBPACK FOOTER **
 ** ./src/components/Header/elements/HeaderLocation.jsx
 **/